/* eslint-disable react/require-default-props */
import React from 'react';
import styled from '@emotion/styled';
import { Button } from '@/atoms';
import { book, heavy, regular, semiBold, colors } from '@/styles';
import { Close, Filter, Search, CancelCircle } from '@/svgs';
import { StyledComponent } from '@/helpers';

export type ErrorScreenProps = StyledComponent & {
  action?: React.MouseEventHandler | null;
  actionLabel?: string | null;
  body?: string;
  icon: 'close' | 'filter' | 'search' | 'cancelCircle';
  title: string;
  iconClassName?: string;
  children?: React.ReactNode;
  isRebrand?: boolean;
};

/**
 * ErrorScreen component
 */
function ErrorScreen({
  action = null,
  actionLabel = '',
  body = '',
  className,
  icon,
  title,
  iconClassName = 'close-background',
  children = null,
  isRebrand = false,
}: ErrorScreenProps) {
  let iconElement = null;
  switch (icon) {
    case 'close':
      iconElement = <Close title="Error" size={`${10 / 2.85}`} />;
      break;
    case 'filter':
      iconElement = <Filter title="Filter" size={`${9 / 2.85}`} />;
      break;
    case 'search':
      iconElement = <Search title="Search" size={`${15 / 2.85}`} />;
      break;
    case 'cancelCircle':
      iconElement = <CancelCircle title="Error" size={`${20 / 2.85}`} fill={colors.boulder} />;
  }
  return (
    <div className={className}>
      <div className={iconClassName}>{iconElement}</div>
      <h1 className="title">{title}</h1>
      {body && <p className="body">{body}</p>}
      {children}
      {action && actionLabel !== null && (
        <Button
          className="action"
          color="boulder"
          label={actionLabel}
          onClick={action}
          outline
          rectangle
          size="small"
          isRebrand={isRebrand}
        />
      )}
    </div>
  );
}

const styledErrorScreen = styled(ErrorScreen)`
  h1.title {
    ${({ isRebrand = false }) => (isRebrand ? semiBold() : heavy())}
    color: ${colors.boulder};
    font-size: 0.875rem;
    margin: 0.75rem auto 0.125rem;
  }

  p.body {
    ${({ isRebrand = false }) => (isRebrand ? regular() : book())}
    color: ${colors.boulder};
    font-size: 0.875rem;
    margin: 0.25rem auto;
  }

  div.close-background {
    align-items: center;
    background-color: ${colors.whiteSmoke};
    border-radius: 0.25rem;
    display: flex;
    height: 2.125rem;
    justify-content: center;
    margin: 0 auto;
    width: 2.125rem;
  }

  .action {
    border-color: ${colors.silverSandAlt};
    border-width: 0.0625rem;
    margin-top: 1.3125rem;
    min-width: 5.625rem;
  }
`;

export default styledErrorScreen;
